import React, { useCallback } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "utils";
import { StandardSearchDropdown } from "components/shared/FilterDropdowns/FilterDropdowns";
import { fetchStandards } from "./csReportsApi";

const Bar = styled.div`
  align-items: flex-end;
  background-color: ${colors.white};
  border: 1px solid ${colors.nightlyWoods200 || "#E5E7EB"};
  border-radius: 8px;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  margin-bottom: 16px;
  padding: 16px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Label = styled.label`
  color: ${colors.nightlyWoods700 || "#374151"};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
`;

export const FiltersBar = ({
  filters,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  teacherRequired = false,
  extraControls = null,
}) => {
  const {
    customers,
    schools,
    teachers,
    customer,
    school,
    teacher,
    standard,
    setCustomer,
    setSchool,
    setTeacher,
    setStandard,
    customersLoading,
    schoolsLoading,
    teachersLoading,
  } = filters;

  const standardFetcher = useCallback(
    (q) =>
      fetchStandards({
        customerId: customer?.value,
        schoolId: school?.value,
        teacherId: teacher?.value,
        startDate,
        endDate,
        q,
      }),
    [customer, school, teacher, startDate, endDate]
  );

  const handleStandardChange = (code, label) => {
    if (!code) {
      setStandard(null);
      return;
    }
    setStandard({ code, label });
  };

  return (
    <Bar>
      <Field>
        <Label>Customer</Label>
        <Select
          options={customers}
          value={customer}
          onChange={setCustomer}
          isLoading={customersLoading}
          placeholder="Select customer..."
          isClearable
        />
      </Field>
      <Field>
        <Label>School</Label>
        <Select
          options={schools}
          value={school}
          onChange={setSchool}
          isLoading={schoolsLoading}
          placeholder={customer ? "All schools" : "Select customer first"}
          isClearable
          isDisabled={!customer}
        />
      </Field>
      <Field>
        <Label>
          Teacher{teacherRequired ? " *" : ""}
        </Label>
        <Select
          options={teachers}
          value={teacher}
          onChange={setTeacher}
          isLoading={teachersLoading}
          placeholder={
            !customer
              ? "Select customer first"
              : teacherRequired
                ? "Select teacher..."
                : "All teachers"
          }
          isClearable={!teacherRequired}
          isDisabled={!customer}
        />
      </Field>
      <Field>
        <Label>Start date</Label>
        <Form.Control
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </Field>
      <Field>
        <Label>End date</Label>
        <Form.Control
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </Field>
      <Field>
        <Label>Domain/Standard</Label>
        <StandardSearchDropdown
          label={null}
          value={standard?.code ?? null}
          displayLabel={standard?.label ?? ""}
          onChange={handleStandardChange}
          disabled={!customer}
          disabledPlaceholder="Select customer first"
          fetchOptions={standardFetcher}
        />
      </Field>
      {extraControls}
    </Bar>
  );
};
